export default __webpack_public_path__ + "static/media/02.6fb3312a.png";